import { ClientLoaderFunctionArgs, useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { Route } from "@route-types/Section/layouts/Supplements/Wealth/+types/WealthSupplementsPage";
import { SupplementsPageContext } from "@routes/Section/layouts/Supplements/utils/types";
import { fetchWealthSupplementsPageData } from "@routes/Section/layouts/Supplements/Wealth/WealthSupplementsPage.server";
import WealthSupplementsPageContent from "@routes/Section/layouts/Supplements/Wealth/WealthSupplementsPageContent";
import { fetchContext, ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

const WealthSupplementsPage = (): React.ReactElement => {
  const context = useLoaderData<SupplementsPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <WealthSupplementsPageContent
      {...context.payload.data}
      gaProps={context.payload.gaProps}
    />
  );
};

export default WealthSupplementsPage;

export const loader = async () => {
  return await fetchWealthSupplementsPageData();
};

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as SupplementsPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};

export const clientLoader = async (args: ClientLoaderFunctionArgs) => {
  const result = (await fetchContext(args)) as {
    context?: SupplementsPageContext;
  };

  if (!result.context) return await args.serverLoader();

  return result.context;
};
